<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
import { ClassificationService } from "../../services/classification.service";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
import MultiSelect from "../Form/Fields/MultiSelect.svelte"; 

  export let placeholder: string = "";
  export let required: boolean = false;
  export let disabled: boolean = false;
  export let clearVisible: boolean = false;
  export let filterVisible: boolean = true;
  export let name: string = "Stati";
  export let value: number[] = null;
  export let small: boolean = false;
  export let limitWidth: boolean = false;

  const dispatch = createEventDispatcher();

  let items: IDropdownItem[] = [];
  let selected  = {};
  
  

  function onFilter(event: CustomEvent) {
    let filter: string = event.detail;
    search(filter);
  }


  async function search(filter: string) {    
    let values = await ClassificationService.searchValueCombo(
      'STATSOLLEC',
      0,
      filter
    ).toPromise();
    items = values.payload || [];
  }

  function onSelect(event: CustomEvent) {
    if (event == null) {
      dispatch("clear");
    } else {
      dispatch("select", event.detail);
    }
  }

  onMount(async () => {
    await search("");
      
    items.forEach(v => {
      //if (v.label == "Si sollecito" || v.label == "In valutazione")
        selected[v.oid] = v;
    });
  });
</script>

<MultiSelect
  {placeholder}
  {required}
  {disabled}
  {clearVisible}
  {filterVisible}
  {name}
  {items}
  {small}
  {limitWidth}
  bind:value
  bind:selected
  on:filter={onFilter}
  on:select={onSelect}
/>
